import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  AddPatientCardagencyside,
  FetchAgencyPlanManagement,
  FetchprivatePay,
  FetchReceipt,
  PrivatePayPayment,
  RemovePatientCardagencyside,
} from "../../../../api/helper";
import { ShowToast } from "../../../../helpers/ToastService";
import { useSelector } from "react-redux";
import "./PatinetPrivatePay.css";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  cardHolderName: Yup.string().required("Card Name is required"),

  cardNumber: Yup.string()
    .required("Card number is required")
    .matches(/^[0-9]{16}$/, "Card number must be 16 digits"),
  expMonth: Yup.number()
    .required("Expiration month is required")
    .min(1, "Invalid month")
    .max(12, "Invalid month"),
  expYear: Yup.number()
    .required("Expiration year is required")
    .min(new Date().getFullYear(), "Year cannot be in the past")
    .max(new Date().getFullYear() + 10, "Year cannot exceed +10 years"),
  CVV: Yup.string()
    .required("CVV is required")
    .matches(/^[0-9]{3,4}$/, "CVV must be 3 or 4 digits"),
});

function PatinetPrivatePay({ info, getDteails }) {
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const [privatepaydata, setprivatepaydata] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [modal, setmodal] = useState(false);
  const [paymenthistory, setpaymenthistory] = useState([]);
  const navigate = useNavigate();

  const closeModal = () => {
    setShowModal(false);
    reset();
  };
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const onSubmit = async (data) => {
    console.log("Form Submitted:", data);
    data.id = info?._id;
    try {
      const response = await AddPatientCardagencyside(data);
      ShowToast(response?.data?.message);
      getDteails();
      reset();
      closeModal();
    } catch (error) {}
  };

  const fetchPrivatepayData = async () => {
    try {
      const respones = await FetchAgencyPlanManagement(
        profiledata?._id,
        "privatePay"
      );
      setprivatepaydata(respones.data.data);
    } catch (error) {
      console.log(error, "===>>");
    }
  };
  const GetPrivatePayList = async () => {
    try {
      const respo = await FetchprivatePay(profiledata?._id, info?._id);
      // console.log(respo?.data?.data?.data,"respo=-=-=-=-")
      setpaymenthistory(respo?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPrivatepayData();
    GetPrivatePayList();
  }, []);

  const handlePay = async (plan) => {
    // console.log(plan?.serviceType,"plan======")
    // return
    if (!profiledata?.isConnctedStripe) {
      setmodal(true);
      return;
    }

    console.log("Paying for plan:", plan);
    // { planId, patientId, patientRequestId, agencyId }
    const requestData = {
      patientId: info.patientId._id,
      planId: plan._id,
      patientRequestId: info._id,
      agencyId: profiledata._id,
      serviceType: plan?.serviceType,
    };
    try {
      const response = await PrivatePayPayment(requestData);
      window.location.href = response.data.data.url;
    } catch (error) {
      console.log(error, "error====");
    }
  };
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const Getreceipt = async (id) => {
    try {
      const respo = await FetchReceipt(id);
      const receiptUrl = respo?.data?.data?.url;

      if (receiptUrl) {
        window.open(receiptUrl, "_blank");
      } else {
        console.log("Receipt URL not found.");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(paymenthistory[0],"paymenthistory[0]=====")
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        {privatepaydata.map((plan) => {
          return (
            <div
              key={plan._id}
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "16px",
                width: "250px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <div style={{ marginBottom: "8px" }}>
                <strong>Status:</strong>{" "}
                <span
                  style={{ color: plan.Status === "Active" ? "green" : "red" }}
                >
                  {plan.Status}
                </span>
              </div>

              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginBottom: "4px",
                }}
              >
                {plan.PlanName}
              </div>
              {plan?.serviceType && (
                <div>
                  <strong>Service Type:</strong> {plan?.serviceType}
                </div>
              )}
              {/* <div style={{ color: "#777", marginBottom: "8px" }}>
            Charged {plan.planType?.toLowerCase()}
          </div> */}

              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  color: "#b99229",
                  marginBottom: "12px",
                }}
              >
                ${plan.fee} / {plan.planType}
              </div>

              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: 0,
                  marginBottom: "12px",
                }}
              >
                <li>{plan?.Benefits}</li>
              </ul>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  style={{
                    padding: "8px 12px",
                    backgroundColor: "#c8a63b",
                    border: "none",
                    borderRadius: "4px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePay(plan)}
                >
                  Pay
                </button>
              </div>
            </div>
          );
        })}
      </div>
      {paymenthistory.length > 0 && (
        <div
          className="section-box_private_pay"
          style={{ maxWidth: "900px", marginTop: 20 }}
        >
          <div className="section-title_private_pay">
            <span>Most Recent Payment</span>
            <span className="badge_private_pay">Paid</span>
          </div>
          <div className="summary-grid">
            <div>
              <strong>Patient Name:</strong>
              <br />
              {paymenthistory[0]?.patientRequestId?.firstName}{" "}
              {paymenthistory[0]?.patientRequestId?.lastName}
            </div>
            <div>
              <strong>Service Type:</strong>
              <br />
              {paymenthistory[0]?.service}
            </div>
            <div>
              <strong>Amount Paid:</strong>
              <br />${paymenthistory[0]?.amount}
            </div>
            <div>
              <strong>Payment Date:</strong>
              <br />
              {new Date(paymenthistory[0]?.createdAt).toLocaleDateString()}
            </div>
            <div>
              <strong>Payment ID:</strong>
              <br />
              {paymenthistory[0]?.paymentIntentId}
            </div>
            <div>
              <strong>Appointment:</strong>
              <br />
              Not yet booked
            </div>
          </div>
          <div className="actions_private_pay">
            <button className="add-button_private_pay" style={{ width: 180 }}>
              <i className="fas fa-calendar-plus" /> Book Appointment
            </button>
            <button
              className="add-button_private_pay outline-button"
              onClick={() => {
                Getreceipt(paymenthistory[0]?.paymentIntentId);
              }}
              style={{ width: 180 }}
            >
              <i className="fas fa-download" /> Download Receipt
            </button>
          </div>
        </div>
      )}

      <div className="section-box_private_pay" style={{ marginTop: 30 }}>
        <div className="section-title_private_pay">
          <span>Payment History</span>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Payment ID</th>
              <th>Amount</th>
              <th>Appointment</th>
              <th>Service</th>
              <th>Receipt</th>
            </tr>
          </thead>
          <tbody>
            {paymenthistory.length > 0 ? (
              paymenthistory.map((payment) => (
                <tr key={payment._id}>
                  <td>{formatDate(payment.createdAt)}</td>
                  <td>{payment.paymentIntentId}</td>
                  <td>${payment.amount}</td>
                  <td>Not yet booked</td>
                  <td>{payment.service}</td>
                  <td>
                    <button
                      className="outline-button"
                      onClick={() => {
                        Getreceipt(payment?.paymentIntentId);
                      }}
                    >
                      <i className="fas fa-download" /> Download
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No Payment Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div
          className="modal_PaymentForm"
          id="addDocumentModal"
          style={{ backgroundColor: "none" }}
        >
          <div
            style={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              border: "1px solid black",
              borderRadius: 7,
            }}
          >
            <div className="payment-container">
              <div
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  width: 50,
                  position: "absolute",
                  right: 18,
                  top: 27,
                }}
                onClick={closeModal}
              >
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkP8S8v6oIxwDrJfdNdFU7FvVNZCcK025zZg&s"
                  style={{ height: 20, width: 20 }}
                />
              </div>
              <h1>Credit Card Payment Form</h1>
              <p className="terms_twoo">
                By continuing you agree to our <a>Terms &amp; Conditions</a>
              </p>
              <form id="paymentForm" onSubmit={handleSubmit(onSubmit)}>
                <div className="radio-group">
                  <div className="radio-group_label">
                    <input
                      type="radio"
                      {...register("cardType", {
                        required: "Card type is required",
                      })}
                      value="credit"
                      required
                    />
                    <label style={{ marginBottom: 20 }}> Credit Card</label>
                  </div>

                  <div className="radio-group_label">
                    <input
                      type="radio"
                      {...register("cardType", {
                        required: "Card type is required",
                      })}
                      value="debit"
                    />

                    <label style={{ marginBottom: 20 }}> Debit Card</label>
                  </div>
                </div>
                <div className="form-group_twoooo">
                  <label htmlFor="cardHolder">Card Holder Name</label>
                  <input
                    type="text"
                    id="cardHolderName"
                    placeholder="Enter Name"
                    {...register("cardHolderName")}
                  />
                  {errors.cardHolderName && (
                    <p className="error-text">
                      {errors.cardHolderName.message}
                    </p>
                  )}
                </div>
                <div className="form-group_twoooo">
                  <label htmlFor="cardNumber">Card Number</label>
                  <input
                    type="text"
                    id="cardNumber"
                    placeholder="**** **** **** 1234"
                    maxLength={16}
                    {...register("cardNumber")}
                  />
                  {errors.cardNumber && (
                    <p className="error-text">{errors.cardNumber.message}</p>
                  )}
                  <div className="card-icons">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
                      alt="Visa"
                    />
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
                      alt="MasterCard"
                    />
                  </div>
                </div>
                <div className="form-inline_twoooo">
                  <div className="form-group_twoooo" style={{ width: "30%" }}>
                    <label htmlFor="expMonth">Exp Month</label>
                    <select id="expMonth" {...register("expMonth")}>
                      <option value="" disabled selected>
                        Select
                      </option>
                      {[...Array(12)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                    {errors.expMonth && (
                      <p className="error-text">{errors.expMonth.message}</p>
                    )}
                  </div>
                  <div className="form-group_twoooo" style={{ width: "30%" }}>
                    <label htmlFor="expYear">Exp Year</label>
                    <select id="expYear" {...register("expYear")}>
                      <option value="" disabled selected>
                        Select
                      </option>
                      {[...Array(11)].map((_, i) => (
                        <option key={i} value={new Date().getFullYear() + i}>
                          {new Date().getFullYear() + i}
                        </option>
                      ))}
                    </select>
                    {errors.expYear && (
                      <p className="error-text">{errors.expYear.message}</p>
                    )}
                  </div>
                  <div className="form-group_twoooo" style={{ width: "30%" }}>
                    <label htmlFor="cvv">CVV</label>
                    <input
                      type="text"
                      id="CVV"
                      placeholder="123"
                      maxLength={4}
                      {...register("CVV")}
                    />
                    {errors.CVV && (
                      <p className="error-text">{errors.CVV.message}</p>
                    )}
                  </div>
                </div>
                {/* <button className="btn-submit">+ Add New Card Now</button> */}
              </form>
            </div>
          </div>
        </div>
      )}
      {modal && (
        <div className="modal_private_pay">
          <div className="modal-content_private_pay">
            <span className="close_private_pay" onClick={() => setmodal(false)}>
              ×
            </span>
            <div
              style={{
                textAlign: "left",
                fontSize: "27px",
                fontWeight: "bold",
              }}
            >
              Stripe Not Configured
            </div>
            <div
              style={{ textAlign: "left", fontSize: "17px", fontWeight: "" }}
            >
              Stripe payment processing is not configured. Please go to{" "}
              <strong>
                Settings → Agency System & Profile → Connect Stripe{" "}
              </strong>
              and connect your Stripe account before continuing.
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 16,
              }}
            >
              <button
                className="btn-secondary_private_pay"
                onClick={() => setmodal(false)}
              >
                Cancel
              </button>
              <button
                className="add-button_private_pay"
                onClick={() => {
                  setmodal(false);
                  navigate("/Settingss?ConfigureStripe=true");
                }}
                 style={{width:150}}
              >
                Configure Stripe
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PatinetPrivatePay;
